import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export const useQueries = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search } = useLocation();

  const handleQuery = (key: string, value: string) => {
    if (search) {
      let params = new URLSearchParams(search);

      // check for empty and duplicate value and remove
      if (value === "") {
        params.delete(key);
      } else if (params.has(key)) {
        params.delete(key);
        params.append(key, value);
      } else {
        params.append(key, value);
      }
      setSearchParams(params);
    } else {
      const params = new URLSearchParams();
      if (value === "") {
        params.delete(key);
      } else {
        params.append(key, value);
      }
      setSearchParams(params);
    }
  };

  return {
    searchParams,
    handleQuery,
    setSearchParams,
  };
};
